
const ApiConst = {
    AdminLogin: '/nebula_api/admin/login',    // 管理员登录
    AdminInfo: '/nebula_api/admin/info',       // 当前管理员信息
    AdminResetPass: '/nebula_api/admin/reset_pass',    // 修改密码

    CommonVideoUpload: '/nebula_api/video/upload',
    CommonVideoInfo: '/nebula_api/video/info',

    GetStsToken: '/nebula_api/admin/sts_token',

    menuList: '/nebula_api/admin/get_menu',       // 获取菜单

    masterRoleList: '/nebula_api/role/master_list',
    copyRole: '/nebula_api/role/copy_role',

    roleList: '/nebula_api/role/list',
    roleSet: '/nebula_api/role/set',
    roleDetail: '/nebula_api/role/detail',
    roleDelete: '/nebula_api/role/delete',
    RoleChatTest: '/nebula_api/role/chat_test',
    RoleCreateCase: '/nebula_api/role/create_case',
    RoleChatCaseList: '/nebula_api/role/chat_case_list',
    RoleDeleteCase: '/nebula_api/role/delete_case',

    RoleSkinList: '/nebula_api/role/skin_list',
    RoleSkinSet: '/nebula_api/role/skin_set',

    RoleEffectList: '/nebula_api/role/role_effect_list',
    RoleEffectSet: '/nebula_api/role/role_effect_set',
    RoleEffectDelete: '/nebula_api/role/role_effect_delete',

    PresetPlayList: '/nebula_api/role/preset_list',
    PresetPlaySet: '/nebula_api/role/preset_set',
    PresetPlayDelete: '/nebula_api/role/preset_delete',

    EffectList: '/nebula_api/role/effect_list',

    ttsList: '/nebula_api/role/tts_list',

    ChannelList: '/nebula_api/channel/list',
    TtsList: '/nebula_api/tts/list',
    WakeList: '/nebula_api/wake/list',

    TtsAudition: '/nebula_api/tts/audition',
    TtsTest: '/nebula_api/tts/get_url',

    RoleCreateScene: '/nebula_api/role/create_scene',
    RoleSceneRename: '/nebula_api/role/scene_rename',
    RoleSceneDelete: '/nebula_api/role/scene_delete',

    KBaseUpload: '/nebula_api/kbase/upload',
    KBaseFileList: '/nebula_api/kbase/file_list',
    KBaseList: '/nebula_api/kbase/list',
    KBaseDelete: '/nebula_api/kbase/delete',
    KBaseSet: '/nebula_api/kbase/set',
    KBaseDetail: '/nebula_api/kbase/detail',
    KBaseFileDelete: '/nebula_api/kbase/delete_file',
}

export default ApiConst;
